export const CREATE_MEETING = '/meetingScheduler/Create'
export const GET_UPCOMING_EVENTS = '/meetingScheduler/upcomingEvents'
export const GET_MEETING_BY_ID = '/meetingScheduler/getMeetingDetailBy'
export const GET_RISK_BY_ID = '/risk/getRiskDetailsBy'
